import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArendeInfoService } from './arende-info.service';
import { Arende } from '../../interfaces/arende.interface';
import { PortalenOvrigInfo } from '../../interfaces/portalenOvrigInfo.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../session/session.service';
import { fadeInAnimation } from '../../_animations/fade-in.animation';
import { SharedStateProvider } from '../../sharedStateProvider/shared-state-provider';

@Component({
    selector: 'app-arende-info',
    templateUrl: './arende-info.component.html',
    styleUrls: ['./arende-info.component.scss'],
    animations: [fadeInAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArendeInfoComponent {

  public arende: Arende;

  constructor(
    protected service: ArendeInfoService,
    protected spinner: NgxSpinnerService,
    protected sessionService: SessionService,
    protected route: ActivatedRoute,
    protected router: Router,
    private sharedStateProvider: SharedStateProvider) {

    this.route.paramMap.subscribe(params => {
      let caseId: string | null = null;

      if (this.sessionService.activeInstance?.roleType !== 'arb') {
        caseId = this.sessionService.getSelectedCaseId();
      } else {
        caseId = params.get('id') || params.get('caseId');
      }

      this.loadArende(caseId);
    });
  }

  public get isLoaded(): boolean {
    return !!this.arende;
  }

  public get getOvrigInfo(): PortalenOvrigInfo[] {
    return this.isLoaded
      ? this.arende.ovrigInfo
        .filter(i => i.portalenOvrigInfo)
        .map(i => ({ ...i.portalenOvrigInfo, sortering: i.sortering }))
      : [];
  }

  private loadArende(caseId: string | null): void {
    const doLoad = () => {
      this.spinner.show();

      if (!caseId && this.sessionService.activeInstance?.roleType !== 'arb') {
        this.spinner.hide();
        this.router.navigate(['/mina-arenden']);
        return;
      }

      this.service.getArendeInfo(this.sessionService.activeInstance.id, caseId)
        .subscribe(
          (result: Arende) => {
            this.spinner.hide();
            this.arende = result;
          },
          () => this.spinner.hide()
        );
    };

    if (!this.sessionService.hasSession) {
      this.router.navigate(['/login']);
      return;
    }

    if (!this.sessionService.hasActiveInstance) {
      this.sessionService.selectInstance(doLoad);
      return;
    }

    doLoad();
  }

  public get instanceName(): string {
    return this.sessionService.activeInstance.name;
  }

  public openUrl(url: string): void {
    window.open(url, "_blank");
  }
}
